module.exports = __webpack_public_path__ + "img/ysgj_036@2x.9d37260f.png";